/**
 * Event handlers for the study editor.
 */

import type { BibleLocation, Study } from '@skjv/common';
import { bibleState } from '@/state/bible-state';
import { generateStudyPdf } from './download-modal';

export const handleBack = () => {
  bibleState.backToStudyList();
};

export const handleNameChange = (name: string) => {
  bibleState.updateEditingStudy({ name });
};

export const handleGroupChange = (studyGroupId: string) => {
  bibleState.updateEditingStudy({ studyGroupId });
};

export const handleStartingLocationDrop = (location: BibleLocation | null) => {
  if (location) bibleState.updateEditingStudy({ startingLocation: location });
};

export const handleEndingLocationDrop = (location: BibleLocation | null) => {
  bibleState.updateEditingStudy({ endingLocation: location || undefined });
};

export const handleWritingLocationDrop = (location: BibleLocation | null) => {
  if (location) bibleState.updateEditingStudy({ writingLocation: location });
};

export const handleMemoryStartDrop = (location: BibleLocation | null) => {
  bibleState.updateEditingStudy({
    memoryStartingLocation: location || undefined,
    memoryEndingLocation: undefined,
  });
};

export const handleMemoryEndDrop = (location: BibleLocation | null) => {
  bibleState.updateEditingStudy({ memoryEndingLocation: location || undefined });
};

export async function handlePrint(study: Study | undefined) {
  if (!study?.id) return;
  try {
    const pdfBlob = await generateStudyPdf(study as Study);
    const pdfUrl = URL.createObjectURL(pdfBlob);
    const printWindow = window.open(pdfUrl);
    if (printWindow) {
      printWindow.onload = () => {
        printWindow.print();
      };
    }
  } catch (error) {
    console.error('Print failed:', error);
    bibleState.showToast('Failed to generate PDF for printing.', 'error');
  }
}
